import { MobileShell } from '@/layouts/mobile/MobileShell';

export function LeaderMobileLayout() {
  return <MobileShell variant="leader" defaultTitle="首页" />;
}
